(() => {
  if (customElements.get('snode-hw-products')) return;

  customElements.define('snode-hw-products', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        const filters = this.querySelectorAll('[data-filter]');
        const products = this.querySelectorAll('[data-category]');
        const count = this.querySelector('[data-product-count]');
        const setCount = value => {
          if (count) count.textContent = `${value} ${value === 1 ? 'product' : 'products'}`;
        };
        setCount(products.length);
        filters.forEach(button => button.addEventListener('click', () => {
          filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
          let visible = 0;
          products.forEach(product => {
            product.hidden = button.dataset.filter !== 'all' && product.dataset.category !== button.dataset.filter;
            if (!product.hidden) visible++;
          });
          setCount(visible);
        }));
      });
    }
  });
})();
